import { render } from "./checkMarkOnlyIcon.svg?vue&type=template&id=404bd2d1"
const script = {}
script.render = render

export default script